// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"1dc7ad60","880":"bea23555"}[chunkId] + ".chunk.js";
};